import LocalStorageKey from 'config/localStorageKey';

export const storeUserTonality = (tonality: string[]) => {
  // noinspection SuspiciousTypeOfGuard
  const safeTonality = tonality.filter(tonality => typeof tonality === 'string');

  localStorage.setItem(LocalStorageKey.UserTonalities, JSON.stringify(safeTonality));
};
